import { render } from "./ChapterDetail.vue?vue&type=template&id=fe09b9b6&scoped=true"
import script from "./ChapterDetail.vue?vue&type=script&lang=js"
export * from "./ChapterDetail.vue?vue&type=script&lang=js"

import "./ChapterDetail.vue?vue&type=style&index=0&id=fe09b9b6&lang=scss&scoped=true"
import "./ChapterDetail.vue?vue&type=style&index=1&id=fe09b9b6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe09b9b6"]])

export default __exports__